import {
  selectAllSalesTeamUsers,
  useGetSalesTeamOnMount,
  useGetSalesTeamUsersOnMount,
} from '@user/store/salesTeam'
import { useSelector } from 'react-redux'
import { useFetchActivityTypesOnMount } from './useFetchActivityTypesOnMount'

export function useData(salesTeamId: number) {
  useGetSalesTeamUsersOnMount(salesTeamId)
  const owners = useSelector(selectAllSalesTeamUsers)

  const { activityTypes } = useFetchActivityTypesOnMount()
  useGetSalesTeamOnMount(salesTeamId)
  return { activityTypes, owners }
}
